import { createContext } from 'react';
import type { SendAnalyticsError, SendAnalyticsEvent } from 'types/analytics';

export interface AnalyticsContextProps {
  sendAnalyticsEvent?: SendAnalyticsEvent;
  sendAnalyticsError?: SendAnalyticsError;
}

const AnalyticsContext = createContext<AnalyticsContextProps>({});

export default AnalyticsContext;
